import {
  REFRESH_USER_FACILITIES,
  SELECT_FACILITY,
  SET_VIEW_FACILITY,
  FACILITY_CUSTOMERID,
  FACILITY_CUSTOMERNAME,
} from '../actions/constants'

const initialState = {
  refreshCustomerList: false,
  customerData: '',
  setFacilityView: false,
  customerId: '',
  customerName: '',
}

export default function (state = initialState, action) {
  switch (action.type) {
    case SELECT_FACILITY:
      return {
        ...state,
        customerType: action.payload,
      }
    case FACILITY_CUSTOMERID:
      return {
        ...state,
        customerId: action.payload,
      }
    case FACILITY_CUSTOMERNAME:
      return {
        ...state,
        customerName: action.payload,
      }
    case REFRESH_USER_FACILITIES:
      return {
        ...state,
        refreshCustomerList: action.payload,
      }

    case SET_VIEW_FACILITY:
      return {
        ...state,
        setViewFacility: action.payload,
      }
    default:
      return {
        ...state,
      }
  }
}
